module.exports = __webpack_public_path__ + "img/imagem-sobre-complexo-03.b963aa9f.png";